// polyfill for clicking outside popovers in iOS 17-18.2
const isIOSVersion = (version) => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  return isIOS && isSafari && navigator.userAgent.includes(`Version/${version}`);
};

if (isIOSVersion('17') || isIOSVersion('18.0') || isIOSVersion('18.1') || isIOSVersion('18.2')) {
  for (const popover of document.querySelectorAll('[popover]:not([popover=manual]')) {
    document.addEventListener('click', (e) => {
      if (!popover.contains(e.target) && popover.matches(':popover-open')) {
        popover.hidePopover();
      }
    });
  }
}
